import React, { useEffect, useState } from "react";
import Header from "../../Header/Header";
import Footer from "../../Footer/Footer";

import { motion } from "framer-motion";


import Whyjoinbg from "./../Pages/Home/Images/whyjoin-background.svg";
import ManImage from "./../Pages/Home/Images/whyjoinMan.svg";
import welcomeimage from "./../Pages/Home/Images/welocomeimage.svg";
import connectNowbg from "./../Pages/Home/Images/connectNowbg.svg";
import counterbg from "./../Pages/Home/Images/counterbg.svg";
import countericon1 from "./../Pages/Home/Images/countericon1.svg";
import countericon2 from "./../Pages/Home/Images/countericon2.svg";
import countericon3 from "./../Pages/Home/Images/countericon3.svg";
import countericon4 from "./../Pages/Home/Images/countericon4.svg";
import manualcleaningproduct from '../Home/Images/Rectangle 2067.png';
import mediaimage1 from "./../Pages/Home/Images/mediaimage1.svg";
import mediaimage2 from "./../Pages/Home/Images/mediaimage2.svg";
import mediaimage3 from "./../Pages/Home/Images/mediaimage3.svg";
import mediaimage4 from "./../Pages/Home/Images/mediaimage4.svg";
import TestimonialImg from "./../Pages/Home/Images/TestimonialImg.svg";


import watercleaning from '../Home/Images/Rectangle 2061.png';
import drycleaning from '../Home/Images/Rectangle 2063.png';
import solutioncleaning from '../Home/Images/Rectangle 2065.png';

import whyclearsolarpenal from '../Home/Images/Rectangle 2058.png';
import exp1 from './Images/Rectangle 7402.png';
import exp2 from './Images/Rectangle 7404.png';
import exp3 from './Images/Rectangle 7406.png';

import homeimage from './Images/6db9dc572c 1.png';

import whychooseus from '../Home/Images/dcf343001e 1.png';

import { blogs } from "../../Blogs copy/BlogData";
import BlogList from "../../Blogs copy/BlogList";

import axios from "axios";
import '../../App.css'


import team from '../Home/Images/Group 17.png';
import Practices from '../Home/Images/Group 16.png';
import Pricing from '../Home/Images/Group 15.png';
import Equipment from '../Home/Images/Group 14.png';

import Enegery from '../Home/Images/Mask group.png';
import Lifespan  from '../Home/Images/Mask group (1).png';
import Cost  from '../Home/Images/Mask group (2).png';
import Prevention   from '../Home/Images/Mask group (3).png';


import { IoMdArrowDropdownCircle } from "react-icons/io";
import { IoMdArrowDropupCircle } from "react-icons/io";
import { FaCircleQuestion } from "react-icons/fa6";


interface gallerydata{
  id:number,
  image:string,
}
const faqs = [
  {
    question: "It is a long established fact that a reader will be distracted by the readable content.",
    answer:
      "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content'.",
  },
  {
    question: "It is a long established fact that a reader will be distracted by the readable content.",
    answer:
      "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content'.",
  },
  {
    question: "It is a long established fact that a reader will be distracted by the readable content.",
    answer:
      "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content'.",
  },
  {
    question: "It is a long established fact that a reader will be distracted by the readable content.",
    answer:
      "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content'.",
  },
  {
    question: "It is a long established fact that a reader will be distracted by the readable content.",
    answer:
      "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content'.",
  },
  {
    question: "It is a long established fact that a reader will be distracted by the readable content.",
    answer:
      "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content'.",
  },
  {
    question: "It is a long established fact that a reader will be distracted by the readable content.",
    answer:
      "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content'.",
  },
  {
    question: "It is a long established fact that a reader will be distracted by the readable content.",
    answer:
      "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content'.",
  },
 
];
const Homes = () => {
  const api = process.env.REACT_APP_API_URL as string;
  const[galleryimagedata, setGalleryImagedata] = useState<gallerydata[]>([]);
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleAccordion = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get<gallerydata[]>(
          `${api}/auth/gallery`
        );

   
        setGalleryImagedata(response.data);
      } catch (error) {
        console.error("gallery Not Found:", error);
      }
    };

    fetchData();
  }, []);

  return (
    <div className="">
      <Header />
      <div className="bgIMG">
  <div className="container mx-auto px-[8%]">
    <div className="flex flex-wrap">
      {/* Left Column */}
      <div className="w-full md:w-1/2 py-5 md:py-0 flex items-center">
        <div>
          <span className="text-lg font-medium welcomeText">
            Welcome to solar cleaning Services
          </span>
          <h1 className="leading-[65px] text-4xl font-bold Heading mt-2">
            Bright Panels, Brighter Savings!
          </h1>
          <p className="mt-4 text-gray-600 HeadingDescription">
            Let Us Keep Your Solar Panels Spotless for Maximum Energy Output and Long-Term Efficiency.
          </p>
        </div>
      </div>
      {/* Right Column */}
      <div className="w-full md:w-1/2 flex justify-center md:justify-end items-end">
        <img
          className="swiperImage w-full max-w-md object-contain object-bottom"
          src={`${homeimage}`}
          alt="Solar Panels"
        />
      </div>
    </div>
  </div>
</div>

{/* About Us Section */}
<div className="bg-gray-100 py-5 px-[8%]">
  <div className="container mx-auto">
    <div className="flex flex-wrap">
      {/* About Us Text */}
      <div className="w-full xl:w-7/12 Aboutus p-9">
        <div className="p-5  rounded">
          <h2 className="text-2xl font-bold AboutUsHeading">About Us</h2>
          <p className="mt-4 text-gray-700 AboutUsPara">
            Welcome to Solar Cleaning Services, your trusted partner in maintaining the efficiency and longevity of your
            solar panels. We are a dedicated team of professionals passionate about helping individuals and businesses
            maximize the benefits of solar energy through expert cleaning and maintenance services.
          </p>
          <p className="mt-4 text-gray-700 AboutUsPara">
            We are a center that tailors a service contract to suit the individual requirements of your installation. Our
            service contract starts from only 150/- Rs per KW monthly for a residential solar rooftop system or from 110/-
            Rs Per KW for a commercial solar panel system. Only annual plan available.
          </p>
        </div>
      </div>

      {/* Explore Boxes */}
      <div className="w-full xl:w-5/12 mt-5 xl:mt-0 pl-4">
        {[
          {
            img: exp1,
            text: "It is a long established fact that a reader will be distracted",
            bgcolor:'#FCDDCB',
            buttonbg:'#B6000D',
          },
          {
            img: exp2,
            text: "It is a long established fact that a reader will be distracted",
            bgcolor:'#D4FCFC',
            buttonbg:'#29AAE1',
          },
          {
            img: exp3,
            text: "It is a long established fact that a reader will be distracted",
            bgcolor:'#A5E129',
            buttonbg:'#29AAE1',
          },
        ].map((item, index) => (
          <div
            key={index}
            className={`flex items-center gap-4 p-4 ${index==0 ? `bg-[#FCDDCB]` : index==1 ?'bg-[#D4FCFC]':'bg-[#F5FDD4]'}  rounded-2xl my-3`}
          >
            <img
              className="w-[131px] h-[140px] object-cover rounded"
              src={item.img}
              alt="Explore More"
            />
            <div className="flex flex-col justify-center">
              <p className="text-gray-700">{item.text}</p>
              <button className={`mt-2 px-4 inline-block max-w-max   py-2 ${index==0 ? `bg-[#B6000D]` : index==1 ?'bg-[#29AAE1]':'bg-[#A5E129]'}  text-white rounded-full `}>
                Explore More
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  </div>
</div>

  <div className="container-fluid py-5 CleanSolar px-[8%]">
    <div className="container">
      <div className="flex flex-wrap gap-2 justify-between py-28">
        <div className="col-lg-5 col-12 align-self-center text-lg-start text-center lg:w-[39%] sm:w-[100%]">
          <img className="img-fluid " src={whyclearsolarpenal}  alt="" />
        </div>
        <div className="col-lg-7 col-12 my-lg-0 my-3 lg:w-[59%] sm:w-[100%]">
          <div className="cleanSolorHeading">Why clean Solar Panels?</div>
          <p className="cleanSolorPara">You might say that you clean your solar panels regularly by yourself and that is
            enough. Although self-cleaning ensures dust cleaning but there is always a risk of damage and electric
            shock. It also reduces mineral residue that blocks sun rays from reaching the cells. So if the output of one
            cell is shaded, it eventually shades the entire panel in the series. Therefore, if you want to maximize your
            output it is of utmost importance to get your solar panels cleaned by experts. Following are some  of the
            benefits you get by doing so</p>
          <button className="ExploreMore2 px-3"  >Know More</button>
        </div>
      </div>
    </div>
  </div>
  <div className="container-fluid py-5 OurServices px-[8%]">
    <div className="container">
      <div className="OurServicesHeading">Our Services</div>
      <div className="OurServicesDescription mt-2 mb-4">Choose from flexible maintenance plans to keep your solar panels
        clean and efficient year-round.</div>
      <div className="grid lg:grid-cols-3 md:grid-cols-2 sm:grid-cols-1 gris-cols-1 gap-4">
        <div className="col-md-4 col-sm-6 col-12 my-2">
          <div className="p-3 OurServicesBox">
            <div className="">
              <img className="OurServicesImg " src={watercleaning}  alt="" />
            </div>
            <div className="OurServicesSubHeading py-3">WATER CLEANING</div>
            <p className="OurServicesSubDescription">It is a long established fact that a reader will be distracted by the
              readable content It is a long established fact that a reader</p>
            <div   className="ServicesKnowMore py-1">Know More <i className="bi bi-arrow-right"></i></div>
          </div>
        </div>
        <div className="col-md-4 col-sm-6 col-12 my-2">
          <div className="p-3 OurServicesBox">
            <div className="">
              <img className="OurServicesImg " src={drycleaning}  alt="" />
            </div>
            <div className="OurServicesSubHeading py-3">DRY CLEANING</div>
            <p className="OurServicesSubDescription">It is a long established fact that a reader will be distracted by the
              readable content It is a long established fact that a reader</p>
            <div   className="ServicesKnowMore py-1">Know More <i className="bi bi-arrow-right"></i></div>
          </div>
        </div>
        <div className="col-md-4 col-sm-6 col-12 my-2">
          <div className="p-3 OurServicesBox">
            <div className="">
              <img className="OurServicesImg " src={solutioncleaning}  alt="" />
            </div>
            <div className="OurServicesSubHeading py-3">SOLUTIONS CLEANING</div>
            <p className="OurServicesSubDescription">It is a long established fact that a reader will be distracted by the
              readable content It is a long established fact that a reader</p>
            <div   className="ServicesKnowMore py-1">Know More <i className="bi bi-arrow-right"></i></div>
          </div>
        </div>

      </div>
    </div>
  </div>
  <div className="container-fluid maximizeImg px-[8%] flex items-center">
    <div className="container">
      <div className="row text-center py-lg-5 pt-sm-5 pt-3">
        <div className="MaximizeHeading my-2">Maximize Your Solar Investment Today!</div>
        <p className="MaximizeDescription my-1">Join hundreds of satisfied customers who trust Solar Pannel Cleaning
          Services to keep their solar panels clean and efficient.</p>
        <div className="my-4"><span   className="MaximizeContactNow py-2 px-3">Contact Now</span></div>
      </div>
    </div>
  </div>
  <div className="container-fluid py-5 OurServices px-[8%]">
    <div className="container">
      <div className="OurServicesHeading">Our product</div>
      <div className="OurServicesDescription mt-2 mb-4">
        Choose from flexible maintenance plans to keep your solar panels clean and efficient year-round.
      </div>
      <div className="grid lg:grid-cols-4 md:grid-cols-3 sm:grid-cols-2 grid-cols-1 gap-4 EqualHeightRow">
        <div className="col-lg-3 col-sm-6 col-12 my-2">
          <div className="p-3 OurServicesBox">
            <div className="">
              <img className="OurProductImg" src={manualcleaningproduct}  alt="" />
            </div>
            <div className="OurProductSubHeading py-3">Manual Cleaning Brush</div>
            <p className="OurProductSubDescription">It is a long established fact that a reader will be distracted by the readable content. It is a long...</p>
            <div   className="ServicesKnowMore py-1">Know More <i className="bi bi-arrow-right"></i></div>
          </div>
        </div>
        <div className="col-lg-3 col-sm-6 col-12 my-2">
          <div className="p-3 OurServicesBox">
            <div className="">
              <img className="OurProductImg" src={manualcleaningproduct}  alt="" />
            </div>
            <div className="OurProductSubHeading py-3">Manual Cleaning Brush</div>
            <p className="OurProductSubDescription">It is a long established fact that a reader will be distracted by the readable content. It is a long...</p>
            <div   className="ServicesKnowMore py-1">Know More <i className="bi bi-arrow-right"></i></div>
          </div>
        </div>
        <div className="col-lg-3 col-sm-6 col-12 my-2">
          <div className="p-3 OurServicesBox">
            <div className="">
              <img className="OurProductImg" src={manualcleaningproduct} alt="" />
            </div>
            <div className="OurProductSubHeading py-3">Manual Cleaning Brush</div>
            <p className="OurProductSubDescription">It is a long established fact that a reader will be distracted by the readable content. It is a long...</p>
            <div   className="ServicesKnowMore py-1">Know More <i className="bi bi-arrow-right"></i></div>
          </div>
        </div>
        <div className="col-lg-3 col-sm-6 col-12 my-2">
          <div className="p-3 OurServicesBox">
            <div className="">
              <img className="OurProductImg" src={manualcleaningproduct} alt="" />
            </div>
            <div className="OurProductSubHeading py-3">Manual Cleaning Brush</div>
            <p className="OurProductSubDescription">It is a long established fact that a reader will be distracted by the readable content. It is a long...</p>
            <div   className="ServicesKnowMore py-1">Know More <i className="bi bi-arrow-right"></i></div>
          </div>
        </div>
      
      </div>
    </div>
  </div>
  <div className="container-fluid WhyChooseUsIMG px-[8%]">
    <div className="container">
      <div className="flex items-center justify-between">
        <div className="col-lg-5 col-12 mt-4">
          <div className="WhyChooseUsHeading">Why Choose Us?</div>
          <div className="flex  my-4 items-center">
            <div><img src={team} alt="" /></div>
            <div className="ms-2 py-1">
              <h5 className="WhyChooseUsSubHeading">Expert Team</h5>
              <p className="WhyChooseUsDescription">Experienced professionals trained in safe and effective cleaning
                techniques.
              </p>
            </div>
          </div>
          <div className="flex  my-4 items-center">
            <div><img src={Practices} alt="" /></div>
            <div className="ms-2 py-1">
              <h5 className="WhyChooseUsSubHeading">Eco-Friendly Practices</h5>
              <p className="WhyChooseUsDescription">We use biodegradable cleaning solutions and minimal water.
              </p>
            </div>
          </div>
          <div className="flex  my-4 items-center">
            <div><img src={Pricing} alt="" /></div>
            <div className="ms-2 py-1">
              <h5 className="WhyChooseUsSubHeading">Affordable Pricing</h5>
              <p className="WhyChooseUsDescription">Transparent pricing with no hidden costs.
              </p>
            </div>
          </div>
          <div className="flex  my-4 items-center">
            <div><img src={Equipment} alt="" /></div>
            <div className="ms-2 py-1">
              <h5 className="WhyChooseUsSubHeading">State-of-the-Art Equipment</h5>
              <p className="WhyChooseUsDescription">Advanced tools for thorough cleaning without damage.
              </p>
            </div>
          </div>
        </div>
        <div className="col-lg-6 col-12 offset-lg-1 align-self-end text-lg-end text-center">
          <img className="swiperImage" src={whychooseus} />
        </div>
      </div>
    </div>
  </div>
  <div className="container-fluid py-5 Benefits-fluid px-[8%]">
    <div className="container">
      <div className="OurServicesHeading">Benefits of Solar Panel Cleaning</div>
      <div className="BenefitsDescription mt-2 mb-5">Maintaining clean solar panels is essential to ensure they operate at
        maximum efficiency. Here are the key benefits of professional solar panel cleaning</div>
        <div className="!grid  lg:grid-cols-4 md:grid-cols-2 sm:grid-cols-2 grid-cols-1  gap-4 BenefitsRow">
  {[
    { img: Enegery, text: "Improved Energy Efficiency" },
    { img: Lifespan, text: "Prolonged Lifespan of Solar Panels" },
    { img: Cost, text: "Cost Savings" },
    { img: Prevention, text: "Prevention of Permanent Damage" },
  ].map((benefit, index) => (
    <div key={index} className="flex justify-center my-2 w-[100%] items-center">
      <div className="p-4 bg-white shadow-md rounded-lg OurBenefitssBox w-[100%] flex flex-col items-center text-center h-full">
        <img
          className="w-20 mx-auto BenefitsImg"
          src={`${benefit.img}`}
          alt={benefit.text}
        />
        <div className="text-lg font-semibold p-3 BenefitsSubHeading flex-grow flex items-center justify-center">
          {benefit.text}
        </div>
      </div>
    </div>
  ))}
</div>



    </div>
  </div>
  <div className="container mx-auto py-10 px-6 max-w-3xl">
      <h2 className="text-2xl font-bold mb-6 text-center">Frequently Asked Questions</h2>
      <div className="space-y-4">
        {faqs.map((faq, index) => (
          <div key={index} className="border rounded-lg overflow-hidden shadow">
            <button
              className="w-full flex justify-between items-center p-4 bg-gray-100 hover:bg-gray-200 focus:outline-none"
              onClick={() => toggleAccordion(index)}
            >
              <div className="flex items-center">
                <FaCircleQuestion
                  height="20px"
                  width="20px"
                  className="mr-2"
                />
                <p className="text-left">{faq.question}</p>
              </div>
              {openIndex === index ? <IoMdArrowDropupCircle size={24} /> : <IoMdArrowDropdownCircle size={24} />}

            </button>
            {openIndex === index && (
              <motion.div
              initial={{ clipPath: "inset(0% 0% 100% 0%)", opacity: 0 }}
              animate={{ clipPath: "inset(0% 0% 0% 0%)", opacity: 1 }}
              exit={{ clipPath: "inset(0% 0% 100% 0%)", opacity: 0 }}
              transition={{ duration: 0.4, ease: "easeInOut" }}
              className="p-4 bg-white"
            >
              {faq.answer}
            </motion.div>
            
            
            )}
          </div>
        ))}
      </div>
    </div>
  <div className="py-10 px-[8%] Benefits-fluid">
  <div className="w-full mx-auto bg-white shadow-lg p-6  formContainer py-12">
    <h2 className="text-5xl font-bold text-center mb-10">Get in Touch</h2>
    <form>
      {/* First Row */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="flex flex-col">
          <label htmlFor="name" className="text-lg font-medium mb-2">Your Name</label>
          <input type="text" id="name" placeholder="Enter your Name"
            className="p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"/>
        </div>
        <div className="flex flex-col">
          <label htmlFor="phoneNum" className="text-lg font-medium mb-2">Phone Number</label>
          <input type="text" id="phoneNum" placeholder="Enter your Phone Number"
            className="p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"/>
        </div>
      </div>

      {/* Second Row */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
        <div className="flex flex-col">
          <label htmlFor="email" className="text-lg font-medium mb-2">Email</label>
          <input type="email" id="email" placeholder="Enter your Email"
            className="p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"/>
        </div>
        <div className="flex flex-col">
          <label htmlFor="services" className="text-lg font-medium mb-2">Services</label>
          <select id="services"
            className="p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500">
            <option>Select Any</option>
            <option value="1">One</option>
            <option value="2">Two</option>
            <option value="3">Three</option>
          </select>
        </div>
      </div>

      {/* Full-Width Row */}
      <div className="mt-4">
        <label htmlFor="message" className="text-lg font-medium mb-2">Message</label>
        <textarea id="message" placeholder="Enter your message"
          className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"></textarea>
      </div>

      {/* Submit Button */}
      <div className="text-right mt-4">
        <button type="submit"
          className="bg-[#A6E129] text-emerald-950 py-3  px-6 rounded-full p-10 w-[210px] hover:skew-x-3 transition">
          Submit
        </button>
      </div>
    </form>
  </div>
</div>

      <Footer />
    </div>
  );
};

export default Homes;
